/* ===============================
   WISHLIST — LOCALSTORAGE ONLY
   =============================== */

const STORAGE_KEY = "wishlist";

/* -------------------------------
   Helpers
-------------------------------- */
function getWishlist() {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
  } catch (e) {
    return [];
  }
}

function saveWishlist(arr) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(arr));
}

function updateHeaderBubble(count) {
  const allWishHeadLink = document.querySelectorAll('.wishlist_link');

  allWishHeadLink.forEach(link => {
    const bubble = link.querySelector('.wishlist-bubble');
    if (!bubble) return;

    if (count > 0) {
      link.classList.add('active');
      bubble.classList.remove('hidden');
      bubble.innerText = count;
    } else {
      link.classList.remove('active');
      bubble.classList.add('hidden');
      bubble.innerText = '';
    }
  });
}

/* -------------------------------
   Init
-------------------------------- */
let wishlistArray = getWishlist();
updateHeaderBubble(wishlistArray.length);

const allWishButtons = Array.from(document.querySelectorAll('.wishlist-Product'));

/* -------------------------------
   Button Click Logic
-------------------------------- */
function onButtonClick(button) {
  const variantId = button.dataset.var;
  const parent = button.closest(".pdp-wishlist-icon");
  const textBox = parent?.querySelector(".wishlist_text_change");

  const exists = wishlistArray.find(item => item.var === variantId);

  if (exists) {
    // REMOVE
    wishlistArray = wishlistArray.filter(item => item.var !== variantId);
    button.classList.remove('active');
    if (textBox) textBox.innerText = "Add to Wishlist";
  } else {
    // ADD
    wishlistArray.push({
      id: button.dataset.id,
      title: button.dataset.title,
      handle: button.dataset.handle, // already /products/...
      var: variantId
    });
    button.classList.add('active');
    if (textBox) textBox.innerText = "Added to Wishlist";
  }

  saveWishlist(wishlistArray);
  updateHeaderBubble(wishlistArray.length);
}

/* -------------------------------
   Initialize Buttons State
-------------------------------- */
allWishButtons.forEach(button => {
  const isActive = wishlistArray.find(
    item => item.var === button.dataset.var
  );

  const parent = button.closest(".pdp-wishlist-icon");
  const textBox = parent?.querySelector(".wishlist_text_change");

  if (isActive) {
    button.classList.add('active');

    if (textBox) {
      textBox.innerText = "Added to Wishlist";
    }
  }
});

document.body.addEventListener('click', (e) => {
  const clickedButton = e.target.closest('.wishlist-Product');

  if (!clickedButton) return;

  console.log('clicked');
  onButtonClick(clickedButton);
});

/* -------------------------------
   Text Click → Trigger Icon Click
-------------------------------- */
document.querySelectorAll(".wishlist_text_change").forEach(textBtn => {
  textBtn.addEventListener("click", () => {
    const wrapper = textBtn.closest(".pdp-wishlist-icon");
    const iconBtn = wrapper?.querySelector(".wishlist-Product");
    if (iconBtn) iconBtn.click();
  });
});
